import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgLikeContained from "../svgs/SvgLikeContained";
import SvgDislikeOutLined from "../svgs/SvgDislikeOutLined";
import SvgComments from "../svgs/SvgComments";
import SvgLikeOutlined from "../svgs/SvgLikeOutlined";
import SvgDislikeContained from "../svgs/SvgDislikeContained";
import { CommentReactions } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import { useState } from "react";
import {
  useBlogCommmentDislikeToggleQuery,
  useBlogCommmentLikeToggleQuery,
} from "@/api/AppApi/services/blogs";
import { numAsString } from "@/utils/functions/functions";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  likes: number;
  disLikes: number;
  reaction: CommentReactions | null;
  isReply: boolean;
  selectedCommentToReply: number | null;
  setSelectedCommentToReply: (selectedComment: null | number) => void;
  commentId: number;
  blogSlug: string;
}
const CommentReaction: React.FC<props> = ({
  likes,
  disLikes,
  reaction,
  isReply,
  selectedCommentToReply,
  setSelectedCommentToReply,
  commentId: commentID,
  blogSlug,
}) => {
  const t = useTranslation();
  const [likeCount, setLikeCount] = useState(likes);
  const [dislikeCount, setDislikeCount] = useState(disLikes);
  const [commentReaction, setReaction] = useState(reaction);

  //TODO --------------actions toggle----------------------------
  const postLike = useBlogCommmentLikeToggleQuery({
    onError: (_res) => {
      // console.error(res);
    },
    onSuccess: (res) => {
      const { dislikes_count, liked, likes_count } = res?.result;
      setDislikeCount(dislikes_count);
      setLikeCount(likes_count);
      setReaction(liked ? CommentReactions.liked : null);
    },
  });
  const postDislike = useBlogCommmentDislikeToggleQuery({
    onError: (_res) => {
      // console.error(res);
    },
    onSuccess: (res) => {
      const { dislike, dislikes_count, likes_count } = res?.result;
      setDislikeCount(dislikes_count);
      setLikeCount(likes_count);
      setReaction(dislike ? CommentReactions.disliked : null);
    },
  });

  return (
    <div className="reaction">
      <div className="like-btns">
        <CustomButton
          onClick={() => {
            setReaction((commentReaction) =>
              commentReaction === CommentReactions.liked
                ? null
                : CommentReactions.liked,
            );
            postLike?.mutate({ blogSlug, commentID, body: {} });
          }}
          type={
            commentReaction === CommentReactions.liked
              ? BtnTypes.primary
              : BtnTypes?.primary_not_selected_like
          }
          size={BtnSizes.semi_small}
          radius={BtnRadius.semi_small}
        >
          <div>
            {commentReaction === CommentReactions.liked ? (
              <>
                <SvgLikeContained /> {t.liked} {`(${numAsString(likeCount)})`}
              </>
            ) : (
              <>
                <SvgLikeOutlined /> {t.like} {`(${numAsString(likeCount)})`}
              </>
            )}
          </div>
        </CustomButton>
        <CustomButton
          onClick={() => {
            setReaction((commentReaction) =>
              commentReaction === CommentReactions.disliked
                ? null
                : CommentReactions.disliked,
            );
            postDislike?.mutate({ blogSlug, commentID, body: {} });
          }}
          type={
            commentReaction === CommentReactions.disliked
              ? BtnTypes.primary
              : BtnTypes?.primary_not_selected_like
          }
          size={BtnSizes.semi_small}
          radius={BtnRadius.semi_small}
        >
          <div>
            {commentReaction === CommentReactions.disliked ? (
              <>
                <SvgDislikeContained /> {t.disliked}{" "}
                {`(${numAsString(dislikeCount)})`}
              </>
            ) : (
              <>
                <SvgDislikeOutLined /> {t.dislike}{" "}
                {`(${numAsString(dislikeCount)})`}
              </>
            )}
          </div>
        </CustomButton>
      </div>

      {!isReply && (
        <CustomButton
          onClick={() => {
            if (selectedCommentToReply === commentID)
              setSelectedCommentToReply(null);
            else setSelectedCommentToReply(commentID);
          }}
          type={
            selectedCommentToReply === commentID
              ? BtnTypes.primary_not_selected
              : BtnTypes.neutral
          }
          size={BtnSizes.small}
          radius={BtnRadius.small}
        >
          <SvgComments /> {t.reply}
        </CustomButton>
      )}
    </div>
  );
};

export default CommentReaction;
